// extracted by mini-css-extract-plugin
module.exports = {"boxContainer":"Carousel_boxContainer__2sluL","box":"Carousel_box__RQdkz","rotate":"Carousel_rotate__2o4Tr"};